module.exports = __webpack_public_path__ + "img/PG2-1-952x410.41a991fe.png";